export const workforceListSelector = state => state.workforce.workforceList;
export const userDetailSelector = state => state.workforce.userDetail;
export const userTypesSelector = state => state.workforce.userTypes
export const userStatusSelector = state => state.workforce.userStatus